import React, { useState } from "react";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import PasswordIcon from "Assets/svg/icon/PasswordIcon";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import Grid from "@material-ui/core/Grid";
import showNotify from "Helpers/Notify";
import UserProfileService from "Services/http/endpoints/userProfile/UserProfileService";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import * as R from "ramda";
import { useTranslation } from "react-i18next";

function ProfilePassword() {
  const { t } = useTranslation();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({
    oldPassword: {
      value: "",
      validation: {
        required: true,
        minLength: 6,
      },
    },
    password: {
      value: "",
      validation: {
        required: true,
        minLength: 6,
      },
    },
  });

  const changePassword = async () => {
    const { oldPassword, password } = controls;

    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          Key: read("userKey"),
          UserName: read("userId"),
          PasswordOld: oldPassword.value,
          PasswordNew: password.value,
        };
        const response = await UserProfileService.putChangePassword(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("mission_accomplished"),
            customClass: "success",
          });
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "warning",
      });
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid(validation);
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={4} xs={12}>
        <Input
          setValue={setValue.bind(this)}
          name="oldPassword"
          value={controls.oldPassword.value}
          validation={controls.oldPassword.validation}
          label={<Translator id="oldPassword" />}
          icon={<PasswordIcon />}
          type="password"
          fullWidth
        />
      </Grid>
      <Grid item sm={4} xs={12}>
        <Input
          setValue={setValue.bind(this)}
          name="password"
          value={controls.password.value}
          validation={controls.password.validation}
          label={<Translator id="newPassword" />}
          icon={<PasswordIcon />}
          type="password"
          fullWidth
        />
      </Grid>
      <Grid
        item
        sm={4}
        xs={12}
        className="d-flex flex-row justify-content-start align-items-center"
      >
        <MuiButton
          loading={loading}
          color="primary"
          title={<Translator id="zakhire" />}
          onClick={changePassword}
          fullwidthOnSm
        />
      </Grid>
    </Grid>
  );
}

export default ProfilePassword;
